import axios from "axios";
let baseUrl;

export async function $fetch(url) {
    console.log(`[${baseUrl}${url}] Fetching ... `)
        // const response = await fetch(`${baseUrl}${url}`)
        // if (response.ok) {
        //     const data = await response.json()
        //     return data
        // } else {
        //     const error = new Error('Niestety, nie udało się pobrać potrzebnych danych. Skontaktuj się z administratorem storny.')
        //     throw error
        // }
    let response = await axios({ method: "GET", url: `${baseUrl}${url}` });
    let responseOK = response && response.status === 200; //&& response.statusText === 'OK';
    if (responseOK) {
        let data = await response.data;
        return data;
    } else {
        console.log(response);
        const error = new Error('Niestety, nie udało się pobrać potrzebnych danych. Skontaktuj się z administratorem storny.')
        throw error
    }
}

export default {
    install(Vue, options) {
        baseUrl = options.baseUrl
        Vue.prototype.$fetch = $fetch
    }
}